import {Component, Input, OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-attachment-preview-modal',
  templateUrl: './attachment-preview-modal.component.html',
  styleUrls: ['./attachment-preview-modal.component.scss']
})
export class AttachmentPreviewModalComponent implements OnInit {

  @Input() document;

  constructor(private httpService: HttpClient, private domSanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.document.url = `${environment.baseUrl}/DocumentRef/GMP//${this.document.id}`
    this.httpService.post(this.document.url, {}, {responseType: 'arraybuffer'}).subscribe((response) => {
      const file = new Blob([response], {
        type: this.document.fileType
      });
      const fileURL = URL.createObjectURL(file);
      this.document.fileContent = this.domSanitizer.bypassSecurityTrustResourceUrl(fileURL);
    });
  }

}
